/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-three-exports.mjs
 * Source: three@0.170.0 (ESM entry)
 * Generated at: 2025-12-12T01:45:19.152Z
 */

export const EMBEDDED_THREE_170_VERSION = "0.170.0" as const;

export const EMBEDDED_THREE_170_NAMED_EXPORTS = [
  "ACESFilmicToneMapping",
  "AddEquation",
  "AdditiveAnimationBlendMode",
  "AdditiveBlending",
  "AddOperation",
  "AgXToneMapping",
  "AlphaFormat",
  "AlwaysCompare",
  "AlwaysDepth",
  "AlwaysStencilFunc",
  "AmbientLight",
  "AnimationAction",
  "AnimationClip",
  "AnimationLoader",
  "AnimationMixer",
  "AnimationObjectGroup",
  "AnimationUtils",
  "ArcCurve",
  "ArrayCamera",
  "ArrowHelper",
  "AttachedBindMode",
  "Audio",
  "AudioAnalyser",
  "AudioContext",
  "AudioListener",
  "AudioLoader",
  "AxesHelper",
  "BackSide",
  "BasicDepthPacking",
  "BasicShadowMap",
  "BatchedMesh",
  "Bone",
  "BooleanKeyframeTrack",
  "Box2",
  "Box3",
  "Box3Helper",
  "BoxGeometry",
  "BoxHelper",
  "BufferAttribute",
  "BufferGeometry",
  "BufferGeometryLoader",
  "ByteType",
  "Cache",
  "Camera",
  "CameraHelper",
  "CanvasTexture",
  "CapsuleGeometry",
  "CatmullRomCurve3",
  "CineonToneMapping",
  "CircleGeometry",
  "ClampToEdgeWrapping",
  "Clock",
  "Color",
  "ColorKeyframeTrack",
  "ColorManagement",
  "CompressedArrayTexture",
  "CompressedCubeTexture",
  "CompressedTexture",
  "CompressedTextureLoader",
  "ConeGeometry",
  "ConstantAlphaFactor",
  "ConstantColorFactor",
  "Controls",
  "createCanvasElement",
  "CubeCamera",
  "CubeReflectionMapping",
  "CubeRefractionMapping",
  "CubeTexture",
  "CubeTextureLoader",
  "CubeUVReflectionMapping",
  "CubicBezierCurve",
  "CubicBezierCurve3",
  "CubicInterpolant",
  "CullFaceBack",
  "CullFaceFront",
  "CullFaceFrontBack",
  "CullFaceNone",
  "Curve",
  "CurvePath",
  "CustomBlending",
  "CustomToneMapping",
  "CylinderGeometry",
  "Cylindrical",
  "Data3DTexture",
  "DataArrayTexture",
  "DataTexture",
  "DataTextureLoader",
  "DataUtils",
  "DecrementStencilOp",
  "DecrementWrapStencilOp",
  "DefaultLoadingManager",
  "DepthFormat",
  "DepthStencilFormat",
  "DepthTexture",
  "DetachedBindMode",
  "DirectionalLight",
  "DirectionalLightHelper",
  "DiscreteInterpolant",
  "DodecahedronGeometry",
  "DoubleSide",
  "DstAlphaFactor",
  "DstColorFactor",
  "DynamicCopyUsage",
  "DynamicDrawUsage",
  "DynamicReadUsage",
  "EdgesGeometry",
  "EllipseCurve",
  "EqualCompare",
  "EqualDepth",
  "EqualStencilFunc",
  "EquirectangularReflectionMapping",
  "EquirectangularRefractionMapping",
  "Euler",
  "EventDispatcher",
  "ExtrudeGeometry",
  "FileLoader",
  "Float16BufferAttribute",
  "Float32BufferAttribute",
  "FloatType",
  "Fog",
  "FogExp2",
  "FramebufferTexture",
  "FrontSide",
  "Frustum",
  "GLBufferAttribute",
  "GLSL1",
  "GLSL3",
  "GreaterCompare",
  "GreaterDepth",
  "GreaterEqualCompare",
  "GreaterEqualDepth",
  "GreaterEqualStencilFunc",
  "GreaterStencilFunc",
  "GridHelper",
  "Group",
  "HalfFloatType",
  "HemisphereLight",
  "HemisphereLightHelper",
  "IcosahedronGeometry",
  "ImageBitmapLoader",
  "ImageLoader",
  "ImageUtils",
  "IncrementStencilOp",
  "IncrementWrapStencilOp",
  "InstancedBufferAttribute",
  "InstancedBufferGeometry",
  "InstancedInterleavedBuffer",
  "InstancedMesh",
  "Int16BufferAttribute",
  "Int32BufferAttribute",
  "Int8BufferAttribute",
  "InterleavedBuffer",
  "InterleavedBufferAttribute",
  "Interpolant",
  "InterpolateDiscrete",
  "InterpolateLinear",
  "InterpolateSmooth",
  "IntType",
  "InvertStencilOp",
  "KeepStencilOp",
  "KeyframeTrack",
  "LatheGeometry",
  "Layers",
  "LessCompare",
  "LessDepth",
  "LessEqualCompare",
  "LessEqualDepth",
  "LessEqualStencilFunc",
  "LessStencilFunc",
  "Light",
  "LightProbe",
  "Line",
  "Line3",
  "LinearFilter",
  "LinearInterpolant",
  "LinearMipmapLinearFilter",
  "LinearMipMapLinearFilter",
  "LinearMipmapNearestFilter",
  "LinearMipMapNearestFilter",
  "LinearSRGBColorSpace",
  "LinearToneMapping",
  "LinearTransfer",
  "LineBasicMaterial",
  "LineCurve",
  "LineCurve3",
  "LineDashedMaterial",
  "LineLoop",
  "LineSegments",
  "Loader",
  "LoaderUtils",
  "LoadingManager",
  "LOD",
  "LoopOnce",
  "LoopPingPong",
  "LoopRepeat",
  "LuminanceAlphaFormat",
  "LuminanceFormat",
  "Material",
  "MaterialLoader",
  "MathUtils",
  "Matrix2",
  "Matrix3",
  "Matrix4",
  "MaxEquation",
  "Mesh",
  "MeshBasicMaterial",
  "MeshDepthMaterial",
  "MeshDistanceMaterial",
  "MeshLambertMaterial",
  "MeshMatcapMaterial",
  "MeshNormalMaterial",
  "MeshPhongMaterial",
  "MeshPhysicalMaterial",
  "MeshStandardMaterial",
  "MeshToonMaterial",
  "MinEquation",
  "MirroredRepeatWrapping",
  "MixOperation",
  "MOUSE",
  "MultiplyBlending",
  "MultiplyOperation",
  "NearestFilter",
  "NearestMipmapLinearFilter",
  "NearestMipMapLinearFilter",
  "NearestMipmapNearestFilter",
  "NearestMipMapNearestFilter",
  "NeutralToneMapping",
  "NeverCompare",
  "NeverDepth",
  "NeverStencilFunc",
  "NoBlending",
  "NoColorSpace",
  "NormalAnimationBlendMode",
  "NormalBlending",
  "NotEqualCompare",
  "NotEqualDepth",
  "NotEqualStencilFunc",
  "NoToneMapping",
  "NumberKeyframeTrack",
  "Object3D",
  "ObjectLoader",
  "ObjectSpaceNormalMap",
  "OctahedronGeometry",
  "OneFactor",
  "OneMinusConstantAlphaFactor",
  "OneMinusConstantColorFactor",
  "OneMinusDstAlphaFactor",
  "OneMinusDstColorFactor",
  "OneMinusSrcAlphaFactor",
  "OneMinusSrcColorFactor",
  "OrthographicCamera",
  "Path",
  "PCFShadowMap",
  "PCFSoftShadowMap",
  "PerspectiveCamera",
  "Plane",
  "PlaneGeometry",
  "PlaneHelper",
  "PMREMGenerator",
  "PointLight",
  "PointLightHelper",
  "Points",
  "PointsMaterial",
  "PolarGridHelper",
  "PolyhedronGeometry",
  "PositionalAudio",
  "PropertyBinding",
  "PropertyMixer",
  "QuadraticBezierCurve",
  "QuadraticBezierCurve3",
  "Quaternion",
  "QuaternionKeyframeTrack",
  "QuaternionLinearInterpolant",
  "RawShaderMaterial",
  "Ray",
  "Raycaster",
  "RectAreaLight",
  "RED_GREEN_RGTC2_Format",
  "RED_RGTC1_Format",
  "RedFormat",
  "RedIntegerFormat",
  "ReinhardToneMapping",
  "RenderTarget",
  "RepeatWrapping",
  "ReplaceStencilOp",
  "ReverseSubtractEquation",
  "REVISION",
  "RGB_BPTC_SIGNED_Format",
  "RGB_BPTC_UNSIGNED_Format",
  "RGB_ETC1_Format",
  "RGB_ETC2_Format",
  "RGB_PVRTC_2BPPV1_Format",
  "RGB_PVRTC_4BPPV1_Format",
  "RGB_S3TC_DXT1_Format",
  "RGBA_ASTC_10x10_Format",
  "RGBA_ASTC_10x5_Format",
  "RGBA_ASTC_10x6_Format",
  "RGBA_ASTC_10x8_Format",
  "RGBA_ASTC_12x10_Format",
  "RGBA_ASTC_12x12_Format",
  "RGBA_ASTC_4x4_Format",
  "RGBA_ASTC_5x4_Format",
  "RGBA_ASTC_5x5_Format",
  "RGBA_ASTC_6x5_Format",
  "RGBA_ASTC_6x6_Format",
  "RGBA_ASTC_8x5_Format",
  "RGBA_ASTC_8x6_Format",
  "RGBA_ASTC_8x8_Format",
  "RGBA_BPTC_Format",
  "RGBA_ETC2_EAC_Format",
  "RGBA_PVRTC_2BPPV1_Format",
  "RGBA_PVRTC_4BPPV1_Format",
  "RGBA_S3TC_DXT1_Format",
  "RGBA_S3TC_DXT3_Format",
  "RGBA_S3TC_DXT5_Format",
  "RGBADepthPacking",
  "RGBAFormat",
  "RGBAIntegerFormat",
  "RGBDepthPacking",
  "RGBFormat",
  "RGBIntegerFormat",
  "RGDepthPacking",
  "RGFormat",
  "RGIntegerFormat",
  "RingGeometry",
  "Scene",
  "ShaderChunk",
  "ShaderLib",
  "ShaderMaterial",
  "ShadowMaterial",
  "Shape",
  "ShapeGeometry",
  "ShapePath",
  "ShapeUtils",
  "ShortType",
  "SIGNED_RED_GREEN_RGTC2_Format",
  "SIGNED_RED_RGTC1_Format",
  "Skeleton",
  "SkeletonHelper",
  "SkinnedMesh",
  "Source",
  "Sphere",
  "SphereGeometry",
  "Spherical",
  "SphericalHarmonics3",
  "SplineCurve",
  "SpotLight",
  "SpotLightHelper",
  "Sprite",
  "SpriteMaterial",
  "SrcAlphaFactor",
  "SrcAlphaSaturateFactor",
  "SrcColorFactor",
  "SRGBColorSpace",
  "SRGBTransfer",
  "StaticCopyUsage",
  "StaticDrawUsage",
  "StaticReadUsage",
  "StereoCamera",
  "StreamCopyUsage",
  "StreamDrawUsage",
  "StreamReadUsage",
  "StringKeyframeTrack",
  "SubtractEquation",
  "SubtractiveBlending",
  "TangentSpaceNormalMap",
  "TetrahedronGeometry",
  "Texture",
  "TextureLoader",
  "TextureUtils",
  "TorusGeometry",
  "TorusKnotGeometry",
  "TOUCH",
  "Triangle",
  "TriangleFanDrawMode",
  "TrianglesDrawMode",
  "TriangleStripDrawMode",
  "TubeGeometry",
  "Uint16BufferAttribute",
  "Uint32BufferAttribute",
  "Uint8BufferAttribute",
  "Uint8ClampedBufferAttribute",
  "Uniform",
  "UniformsGroup",
  "UniformsLib",
  "UniformsUtils",
  "UnsignedByteType",
  "UnsignedInt248Type",
  "UnsignedInt5999Type",
  "UnsignedIntType",
  "UnsignedShort4444Type",
  "UnsignedShort5551Type",
  "UnsignedShortType",
  "UVMapping",
  "Vector2",
  "Vector3",
  "Vector4",
  "VectorKeyframeTrack",
  "VideoTexture",
  "VSMShadowMap",
  "WebGL3DRenderTarget",
  "WebGLArrayRenderTarget",
  "WebGLCoordinateSystem",
  "WebGLCubeRenderTarget",
  "WebGLMultipleRenderTargets",
  "WebGLRenderer",
  "WebGLRenderTarget",
  "WebGLUtils",
  "WebGPUCoordinateSystem",
  "WireframeGeometry",
  "WrapAroundEnding",
  "ZeroCurvatureEnding",
  "ZeroFactor",
  "ZeroSlopeEnding",
  "ZeroStencilOp"
] as const;
